import { Injectable } from '@angular/core';
import {
    TramitesRequisitosInterface,
    TramiteTipoRequisitoItem
} from "../../tramites/components/interfaces/tramites.interface";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment.development";
let apiVucUrl = environment.apiVucUrl
@Injectable({
  providedIn: 'root'
})
export class TramiteRequisitoService {

  constructor(private http: HttpClient) { }

    getRequisitosTramitePorTipo(idTramite: number, idTipoTramite?: TramiteTipoRequisitoItem[]) {
        const idTipos = idTipoTramite?.map(t => t.idTipoTramite);
        console.log(`idTramite=${idTramite}`)
        console.log(`idTipoTramite=${idTipos}`)
        let url = apiVucUrl + `api/v1.0/tramites/requisitos/${idTramite}?idTipos=${idTipos ? idTipos : ''}`;
        console.log(url)
        return this.http.get<TramitesRequisitosInterface[]>(url)
    }

}
